import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Plus, ArrowUpRight, Trash2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import PageHeading from "@/components/PageHeading";

export default function Brands() {
  const navigate = useNavigate();
  const [brands, setBrands] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ name: "", referente: "", settore: "" });

  const load = () => api.get("/brands").then(({ data }) => setBrands(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    if (!form.name.trim()) return;
    try {
      await api.post("/brands", form);
      setForm({ name: "", referente: "", settore: "" });
      setAdding(false);
      toast.success("Brand creato");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  const remove = async (b, e) => {
    e.stopPropagation();
    if (!window.confirm(`Eliminare il brand "${b.name}" con tutti i piani, task e report?`)) return;
    try {
      await api.delete(`/brands/${b.id}`);
      toast.success("Brand eliminato");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="brands-page">
      <PageHeading kicker="02 · CLIENTI" title="Brand e Clienti" subtitle="Anagrafiche, brand kit, documenti e obiettivi di ogni cliente." />

      <div className="mb-8">
        {adding ? (
          <div className="bg-white/70 border border-white p-5 max-w-md">
            <input autoFocus value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nome brand *" data-testid="new-brand-name" className="field-line mb-3" />
            <input value={form.referente} onChange={(e) => setForm({ ...form, referente: e.target.value })} placeholder="Referente" data-testid="new-brand-referente" className="field-line mb-3" />
            <input value={form.settore} onChange={(e) => setForm({ ...form, settore: e.target.value })} placeholder="Settore (es. beauty)" data-testid="new-brand-settore" className="field-line mb-4" />
            <div className="flex gap-3">
              <button onClick={create} data-testid="confirm-brand-button" className="bg-black text-greige px-6 py-2 text-xs uppercase tracking-widest">Crea</button>
              <button onClick={() => setAdding(false)} className="border border-black px-6 py-2 text-xs uppercase tracking-widest hover:bg-black hover:text-greige transition-colors">Annulla</button>
            </div>
          </div>
        ) : (
          <button onClick={() => setAdding(true)} data-testid="create-brand-button" className="inline-flex items-center gap-2 bg-black text-greige px-6 py-3 uppercase tracking-widest text-xs hover:bg-stone2e transition-colors">
            <Plus strokeWidth={1.5} size={16} /> Nuovo brand
          </button>
        )}
      </div>

      {brands.length === 0 ? (
        <p className="font-editorial text-xl text-stone2e italic py-12 text-center">Nessun brand. Creane uno per iniziare.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {brands.map((b) => (
            <div key={b.id} onClick={() => navigate(`/brand/${b.id}`)} data-testid={`brand-card-${b.id}`} className="group bg-white/60 backdrop-blur-md border border-white hover:border-black/40 transition-colors p-7 cursor-pointer">
              <div className="flex items-start justify-between">
                <ArrowUpRight strokeWidth={1.25} size={22} className="text-stone2e group-hover:text-ink transition-colors" />
                <button onClick={(e) => remove(b, e)} data-testid={`delete-brand-${b.id}`} className="text-stone2e hover:text-ink opacity-0 group-hover:opacity-100 transition-opacity">
                  <Trash2 strokeWidth={1.5} size={16} />
                </button>
              </div>
              <h3 className="font-display text-2xl text-ink mt-5">{b.name}</h3>
              <p className="font-body text-sm text-stone2e mt-1">{b.referente || "—"}</p>
              <p className="meta-label mt-4">{(b.settore || "SETTORE N.D.").toUpperCase()}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
